<p-button [styleClass]="getStyleClass()"
          [label]="label"
          [iconPos]="iconPos"
          [type]="type"
          [icon]="icon"
          (onClick)="onClick.emit()"
          [disabled]="disabled">
  <ng-content></ng-content>
</p-button>
